import React, { useState, useEffect } from 'react'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Appt Components
import Box from '../../components/simple/box/Box'
import Form from '../../components/simple/form/Form.js'
import FormField from '../../components/simple/formField/FormField.js'
import FontAwesome from '../../components/compound/fontAwesome/FontAwesome'
import Divider from '../../components/simple/divider/Divider'
import H2 from '../../components/simple/heading/H2.js'
import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../../components/simple/text/Text'
import TextArea from '../../components/simple/input/TextArea'
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import Button from '../../components/simple/button/Button.js'
import MultiSelectCard from '../../components/compound/multiSelectCard/MultiSelectCard.js'

const normalizeList = (values = []) => {
  const normalized = []
  const seen = new Set()

  ;(Array.isArray(values) ? values : []).forEach((value) => {
    const trimmed = typeof value === 'string' ? value.trim() : ''
    const dedupeKey = trimmed.toLowerCase()

    if (!trimmed || seen.has(dedupeKey)) {
      return
    }

    seen.add(dedupeKey)
    normalized.push(trimmed)
  })

  return normalized
}

const getOptionsFromValue = (value) => {
  if (Array.isArray(value)) {
    return normalizeList(value)
  }

  if (value && typeof value === 'object') {
    const original = Array.isArray(value.original)
      ? value.original.map(item => item?.value)
      : []

    return normalizeList([...original])
  }

  return []
}

const getSelectedFromValue = (value) => {
  if (Array.isArray(value)) {
    return normalizeList(value)
  }

  if (value && typeof value === 'object') {
    const original = Array.isArray(value.original)
      ? value.original.filter(item => item?.checked).map(item => item?.value)
      : []

    return normalizeList([...original])
  }

  return []
}

function BehaviourDetails (props) {
  const specialKeys = props.specialKeys || []
  const questions = props.questions || []

  const [localValues, setLocalValues] = useState(props.behaviourPlanValues)
  // const [optionPoolByKey, setOptionPoolByKey] = useState({})

  const handleMultiSelectChange = (key, value) => {

    // console.log("handleMultiSelectChange", key, value, normalizeList(value))

    setLocalValues(previousValues => ({
      ...previousValues,
      [key]: value?.join(', ')
    }))
  }

  useEffect(() => {
    setLocalValues(props.behaviourPlanValues)
  }, [props.behaviourPlanValues])

  // Submit form values
  const submitForm = async () => {
    // props.setBehaviourPlanValues(localValues)
    props.submitForm(true, localValues)
  }
  const previousPage = () => {
    props.previousPage(localValues)
  }

  const nextPage = () => {
    props.nextPage(localValues)
  }

  const deleteDraft = () => {
    props.deleteDraft()
  }

  const keysToLoop = [
    'lowLevelBehaviour',
    'lowLevelTried',
    'lowLevelOtherThings',
    'lowLevelHelpMyself',
    'mediumLevelBehaviour',
    'mediumLevelTried',
    'mediumLevelOtherThings',
    'mediumLevelHelpMyself',
    'highLevelBehaviour',
    'highLevelTried',
    'highLevelOtherThings',
    'highLevelHelpMyself'
  ]

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small'>
      <Box
        gap='small'
        margin={{ horizontal: 'small' }}
        pad='small'
        round='small'
      >
        <Box fill direction='row' gap='small'>
          <H2 margin={{ vertical: 'none' }}>Behaviour Details</H2>
          <Button label={<Text><FontAwesomeIcon color='#ff8300' icon={['fas', 'question-circle']} /></Text>} plain tip='This is the Behaviour Details page of the Incident Report' />
        </Box>
        <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
        <Form
          //   validate='blur'
          onChange={nextValue => {
            setLocalValues(nextValue)
          }}
          onSubmit={() => {
            submitForm(localValues)
          }}
          value={localValues}
        >
          <Box>
            <Text weight='bold' size='medium' margin={{ bottom: 'medium' }}>As concisely as possible</Text>
          </Box>

          <ResponsiveGrid
            rows={['auto']}
            columns={{
              small: ['auto', 'auto', 'auto', 'auto'],
              // medium: ['auto', 'auto'],
              // large: ['auto', 'auto'],
              // xlarge: ['auto', 'auto', 'auto', 'auto']
            }}
            gap='small'
          >
          {/* <Grid
            rows={['auto', 'auto', 'auto', 'auto']}
            columns={['auto', 'auto', 'auto', 'auto']}
            gap='small'
            areas={[
              { name: 'main', start: [0, 0], end: [1, 1] }
            ]}
          > */}


            {
              keysToLoop?.map((key, index) => {
                return (
                  <>
                  <MultiSelectCard
                    key={key}
                    title={questions[index]?.questionText}
                    columns={['auto']}
                    // options={optionPoolByKey[key] || []}
                    // selected={getSelectedFromValue(localValues?.[key])}


                    options={localValues?.recommendations?.[key]}
                    selected={localValues?.lastSubmission?.[key]}
                    onChange={(newValue) => handleMultiSelectChange(key, newValue)}

                  />
                  {/* <FormField
                    key={`${key}-details`}
                    label={questions[index]?.questionText}
                    name={questions[index]?.key}
                  >
                    <TextArea
                      name={questions[index]?.key}
                    />
                  </FormField> */}
                  </>
                )
              })
            }
          </ResponsiveGrid>

          <Box>

            <FormField
              label={questions[12].questionText}
              name={questions[12].key}
            >
              <TextArea
                name={questions[12].key}
              />
            </FormField>
          </Box>

          <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />

          <Box direction='row' gap='small' justify='between' margin={{ top: 'medium' }}>
            <ActionButton label='< Back' onClick={() => previousPage()} secondary />
            <Box direction='row' gap='small'>
              <ActionButton icon={<FontAwesome icon={['fal', 'save']} color='#fff' />} label='Save for later' onClick={() => submitForm()} />
              <ActionButton icon={<FontAwesome icon={['fal', 'trash']} color='#fff' />} label='Delete Draft' onClick={() => deleteDraft()} />
            </Box>
            <ActionButton label='Next Page' onClick={() => nextPage()} primary />
          </Box>
        </Form>
      </Box>
    </Box>
  )
}

export default BehaviourDetails
